module.exports = __webpack_public_path__ + "static/media/14UNEP18.4f7bfa6e.jpg";